import script from "./match-summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./match-summary.vue?vue&type=script&setup=true&lang=ts"

import "./match-summary.vue?vue&type=style&index=0&id=91e89fe6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91e89fe6"]])

export default __exports__